<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half"><span class="bold">The 614th Tank Destroyer Battalion</span></p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?f130bd84